import StatusModel from 'Models/StatusModel';
import GameModel from 'Models/GameModel';

function validateOrderData(context) {
  // SKY-4298: Включаем обязательную проверку на выбор платформы для Фифы, Диабло и POE
  if (context.availablePlatforms
    && (context.currentItem.platform_id === undefined || context.currentItem.platform_id === null)
    && [GameModel.FIFA.id, GameModel.DIABLO_4.id, GameModel.PATH_OF_EXILE.id].includes(context.currentItem.game_id)) {
    // eslint-disable-next-line no-alert
    alert('Platform not specified');
    return false;
  }

  if (context.currentItem.status === StatusModel.IN_PROGRESS.id
    && !context.booster_id) {
    // eslint-disable-next-line no-alert
    alert('Pro gamer not specified');
    return false;
  }

  if (
    (context.currentItem.status === StatusModel.ON_AUCTION.id || context.booster_id)
    && Number.isNaN(parseFloat(context.currentItem.booster_price))
  ) {
    // eslint-disable-next-line no-alert
    alert('Pro gamer reward not specified');
    return false;
  }

  if (context.currentItem.booster_price > (context.currentItem.sum_in_usd * 100)
    && context.currentItem.sum_in_usd !== 0
  ) {
    // eslint-disable-next-line no-alert
    alert('Pro gamer reward can\'t be more then order price');
    return false;
  }

  if (context.initialCurrentItem?.status !== context.currentItem.status
    && context.currentItem.status === StatusModel.MANUAL_DISTRIBUTION.id
    && context.currentItem.booster_id) {
    if (!window.confirm('Change status to "Manual distribution"? Pro gamer will be reset.')) {
      return false;
    }
    context.booster_id = null;
    context.booster_change_reason = 'Manual distribution';
  }

  if (context.booster_id !== context.currentItem.booster_id) {
    if (![
      StatusModel.MANUAL_DISTRIBUTION.id,
      StatusModel.ON_AUCTION.id,
      StatusModel.IN_PROGRESS.id,
    ].includes(context.currentItem.status)
      && !context.booster_change_reason) {
      // eslint-disable-next-line no-alert
      alert('Specify pro gamer change reason');
      return false;
    }

    if (context.booster_id
      && [StatusModel.MANUAL_DISTRIBUTION.id, StatusModel.ON_AUCTION.id].includes(context.currentItem.status)) {
      context.setOrderStatus(context.availableStatuses.find((s) => s.id === StatusModel.IN_PROGRESS.id));
    }
  }

  return true;
}

const orderDateFieldsToTransform = ['auction_at', 'created_at', 'deadline_at', 'start_at'];

// Нужно что бы чинить даты на iphone
function parseOrderDates(order) {
  orderDateFieldsToTransform.forEach((key) => {
    if (order[key] instanceof Date || typeof order[key] === 'number') {
      return;
    }

    if (key in order && order[key]) {
      order[key] = new Date(order[key].replace(' ', 'T'));
    }
  });

  return order;
}

function getOrderPriceWithoutCommission(order) {
  const priceModifications = order.price_modifications;
  // eslint-disable-next-line camelcase
  let { sum, sum_in_usd } = order;

  if (priceModifications?.length) {
    priceModifications.forEach((modification) => {
      sum -= modification.diff;
      // eslint-disable-next-line camelcase
      sum_in_usd -= modification.diff;
    });
  }

  return {
    _clean_sum: sum?.toFixed(2),
    // eslint-disable-next-line camelcase
    _clean_sum_in_usd: sum_in_usd ? sum_in_usd.toFixed(2) : null,
  };
}

function parseOrders(orders) {
  return orders?.map((order) => {
    // eslint-disable-next-line camelcase
    const { _clean_sum, _clean_sum_in_usd } = getOrderPriceWithoutCommission(order);
    return parseOrderDates({ ...order, _clean_sum, _clean_sum_in_usd });
  });
}

// eslint-disable-next-line import/prefer-default-export
export { validateOrderData, parseOrders, getOrderPriceWithoutCommission };
